module.exports = __webpack_public_path__ + "media/images/ready/icon-clock-d122aaac4aa8be5d29fd308e7d05564f.svg";